export function isProductionDomain() {
  return location.hostname === 'jobian.com';
}
